<app-loader [isBusy]="isBusy">
    <ng-template>
        <form [formGroup]="form" (ngSubmit)="holdServiceRequestItems()">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row card-border-top">
                    <div class="card-body pt-0">
                        @if (serviceRequestVersionId !== null && !serviceRequestItemIds?.length && !isUnholdAction) {
                            <div class="row">
                                <div class="col pt-3">
                                    {{ 'This action will put Hold on this entire Service Request.' | translate }}
                                </div>
                            </div>
                        }
                        @if (
                            shipmentType === 'NONCNTC' &&
                            serviceRequestVersionId === null &&
                            serviceRequestItemIds !== null
                        ) {
                            <div class="row">
                                <div class="col pt-3">
                                    {{
                                        isUnholdAction
                                            ? 'This action will Unhold entire Shipment Item for selected records.'
                                            : ('This action will put Hold on entire Shipment Items.' | translate)
                                    }}
                                </div>
                            </div>
                        }
                        <div class="row">
                            <div class="col pt-3">
                                {{ 'Please confirm before holding/unholding selected items.' | translate }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-3">
                                <div class="row">
                                    @if (!isUnholdAction || commonActiveHoldTypeIds.length > 1) {
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <form-dropdown
                                                formControlName="cargoHoldTypeId"
                                                labelText="{{ 'Cargo Hold Type' | translate }}"
                                                [codeListValues]="cargoHoldTypes"></form-dropdown>
                                        </div>
                                    }
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <form-textbox
                                            labelText="{{
                                                isUnholdAction
                                                    ? 'Cargo Unhold Remark'
                                                    : ('Cargo Hold Remark' | translate)
                                            }}"
                                            formControlName="cargoHoldRemark"></form-textbox>
                                    </div>
                                    @if (!isUnholdAction) {
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <kendo-fileselect
                                                [restrictions]="attachmentFileUploadRestrictions"
                                                [multiple]="true"
                                                (select)="fileSelected($event)"
                                                (remove)="fileRemoved($event)">
                                                <kendo-upload-messages
                                                    select="{{ 'Select files' | translate }}"
                                                    dropFilesHere="{{
                                                        'Drop files here to select' | translate
                                                    }}"></kendo-upload-messages>
                                            </kendo-fileselect>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    class="btn btn-sm btn-primary mr-2"
                    type="button"
                    [disabled]="!(form.valid && form.dirty)"
                    (click)="holdServiceRequestItems()">
                    {{ isUnholdAction ? 'Unhold' : ('Hold' | translate) }}
                </button>
                <button class="btn btn-sm btn-secondary" type="button" (click)="activeModal.close(null)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        </form>
    </ng-template>
</app-loader>
